<work-ui-gallery [galleryDocuments]="this.dataPaginated?.data ?? []"
                 [projectId]="project().id"
                 [selectModeEnabled]="false"
                 [annotationEnabled]="true"
                 (newDocumentsUploaded)="load()"
                 (documentAnnotated)="load()"
                 [documentTypeId]="2"
                 [documentsubtypeId]="9"
                 [documentTypeIdentifierName]="WorkDocumenttypeIdentifierNameEnum.Projektfoto" />
